import CrudListing from "components/crud/CrudListing";

import PartyModal from "./PartyModal";
import { partyColumns } from "./columns";

import {
    getParties,
    deleteParty,
} from "services/api/partyApi";


export default function Parties() {

    return (

        <CrudListing

            title="Parties / Booksellers"

            columns={partyColumns}

            Modal={PartyModal}


            fetchData={async (
                page,
                limit,
                search
            ) => {

                const response =
                    await getParties(
                        page,
                        limit,
                        search
                    );


                /*
                API response:
        
                {
                  status: true,
                  data: {
                    parties: [...],
                    pagination: {...}
                  }
                }
        
                Normalize it for CrudListing.
                */

                return {
                    data: {
                        data: {

                            records:
                                Array.isArray(
                                    response?.data?.parties
                                )
                                    ? response.data.parties
                                    : [],

                            pagination:
                                response?.data?.pagination || {},

                        },
                    },
                };

            }}


            deleteData={deleteParty}

            responseDataKey="records"

            searchPlaceholder="Search Party..."

            addButtonText="Add Party"

        />

    );

}